import React, { Component } from "react";

export class TopInfo extends Component {
  render() {
    return (
      <section className="topInfo">
        <div className="infoLine1">
          <div>
            <span>information</span>
            <span>IPB</span> <span>covid19@ipb.pt</span>
          </div>
          <div>
            <i className="fas fa-at"></i> Saúde24{" "}
            <span className="email">atendimento@sns24.gov.pt</span>
            <i className="fas fa-phone-alt"></i> SNS 24{" "}
            <span>808 24 24 24</span>
          </div>
        </div>
        <div className="infoLine2">
          <div>
            <i className="fas fa-external-link-alt"></i>
            <a
              href="https://covid19estamoson.gov.pt/"
              target="_blank"
              rel="noopener noreferrer"
            >
              covid19estamoson.gov.pt
            </a>
          </div>
          <div>
            <i className="fas fa-external-link-alt"></i>
            <a
              href="https://www.acm.gov.pt/-/covid-19-medidas-orientacoes-e-recomendacoes"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.acm.gov.pt
            </a>
          </div>
        </div>
      </section>
    );
  }
}

export default TopInfo;
